import { NothingMessage, Texto } from '@gravitate-js/excalibrr'
import { Checkbox, Col, Row, Spin } from 'antd'
import React from 'react'

export function SupplyOptionSelector({ supplyOptions, setCurveIds, curveIds, queryStatus }) {
  return (
    <div className='flex-1 vertical-flex p-3' style={{ position: 'relative', overflow: 'scroll' }}>
      <OptionHeader />
      <SupplyList />
    </div>
  )

  function SupplyList() {
    if (queryStatus === 'pending') {
      return (
        <div className='h-100 vertical-flex-center'>
          <Spin size='large' />
        </div>
      )
    }
    if (!supplyOptions?.length) {
      return (
        <NothingMessage title='No Results' message='No supply options exist in the system matching those parameters.' />
      )
    }
    return supplyOptions.map((option, i) => {
      const rowCurveIds = option.components.map((i) => i.curve_id)
      const checked = curveIds?.length && rowCurveIds.every((val, index) => val === curveIds[index])
      return <SupplyOptionItem item={option} key={i} checked={checked} setCurveIds={setCurveIds} />
    })
  }
}

function SupplyOptionItem({ item = {}, checked, setCurveIds }) {
  const { components = [] } = item
  const curveIds = components.map((i) => i.curve_id)
  return (
    <div
      onClick={() => setCurveIds(checked ? [] : curveIds)}
      className='bg-1 bordered mt-3 py-3'
      style={{ borderRadius: '5px', cursor: 'pointer', border: checked && 'solid 2px var(--theme-color-2)' }}
    >
      <Row>
        <Col className='flex items-center justify-center' span={2}>
          <Checkbox
            checked={checked}
            onChange={(e) => {
              setCurveIds(checked ? [] : curveIds)
            }}
          />
        </Col>
        <Col span={13}>
          {components.map((component, i) => (
            <Row className='mt-3' key={i}>
              <Col span={10}>
                <Texto category='p2' weight='bold'>
                  {component.terminal}
                </Texto>
                <Texto appearance='medium'>{component.supplier}</Texto>
              </Col>
              <Col span={7}>
                <Texto style={{ textTransform: 'capitalize' }} category='p2' weight='bold'>
                  {component.price_type}
                </Texto>
                <Texto appearance='medium'>{component.product}</Texto>
              </Col>
              <Col span={7}>
                <Texto style={{ textTransform: 'capitalize' }} category='p2' weight='bold'>
                  ${component.price}
                </Texto>
                <Texto
                  weight={component.contract ? 'bold' : 'normal'}
                  appearance={component.contract ? 'secondary' : 'medium'}
                >
                  {component.contract || 'No Contract'}
                </Texto>
              </Col>
            </Row>
          ))}
        </Col>
        <Col span={8} style={{ display: 'flex', alignItems: 'center' }}>
          <Row className='  flex-1'>
            <Col span={9}>
              <Texto category='p2' align='right' weight='bold'>
                {item.miles?.toFixed(0)} MI
              </Texto>
              <Texto style={{ textTransform: 'capitalize' }} align='right' category='p2'>
                @ ({`$${item.rate?.toFixed(4).replace(/^0+/, '')}`})
              </Texto>
            </Col>

            <Col className='vertical-flex-center' span={15}>
              <Texto align='right' style={{ textTransform: 'capitalize' }} category='h6' weight='bold'>
                ${(Math.round(item.total) || '').toLocaleString('en')}
              </Texto>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}
function OptionHeader() {
  return (
    <Row className='pt-3'>
      <Col span={2} />
      <Col span={22}>
        <Row>
          <Col span={6}>
            <Texto appearance='medium' weight='bold'>
              TERMINAL
            </Texto>
          </Col>
          <Col span={4}>
            <Texto appearance='medium' weight='bold'>
              SUPPLY TYPE
            </Texto>
          </Col>
          <Col span={5}>
            <Texto appearance='medium' weight='bold'>
              PRICE
            </Texto>
          </Col>

          <Col span={3}>
            <Texto appearance='medium' align='right' weight='bold'>
              FREIGHT
            </Texto>
          </Col>
          <Col span={5}>
            <Texto appearance='medium' align='right ' weight='bold'>
              TOTAL
            </Texto>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
